import {createMuiTheme} from '@material-ui/core/styles';

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#2797E8'
    },
    secondary: {
      main: '#697B8C'
    }
  },
  typography: {
    useNextVariants: true
  }
});

export default theme;
